import { App } from 'vue'
import SlideValidate from './SlideValidate.vue'

export default {
  install(app: App) {
    app.component('SlideValidate', SlideValidate)
  }
}
